export default "__VITE_ASSET__40a10210__"